// extracted by mini-css-extract-plugin
export var active = "_1r-7";
export var container = "_1r-0";
export var evenWidth = "_1r-4";
export var large = "_1r-5";
export var outlet = "_1r-8";
export var slide = "_1r-2";
export var small = "_1r-6";
export var tab = "_1r-3";
export var tabs = "_1r-1";